import type {AxiosInstance, AxiosPromise} from 'axios';
import {ENDPOINTS} from 'general/constants';
import {getExtraUrlData, getRemoteIp, getTimezone} from './helpers';
import {get} from 'svelte/store';
import {modal} from 'general/store';

export const emailSubscribe = <T>(
    instance: AxiosInstance,
    data: {email: string; affiliateId?: string; offerGiven: string; refId: string},
): AxiosPromise<T> => {
    if (process.env.NODE_ENV === 'development') {
        if (data.email === 'subscribed@test.com') {
            return new Promise((_, reject) => {
                setTimeout(() => {
                    reject({
                        response: {
                            data: {
                                code: 3,
                                message: 'This email is subscribed.',
                            },
                        },
                    });
                }, 300);
            });
        } else if (data.email === 'reject@test.com') {
            return new Promise((_, reject) => {
                setTimeout(() => {
                    reject({
                        response: {
                            data: {
                                code: 2,
                                message: 'Please enter a valid email address.',
                            },
                        },
                    });
                }, 300);
            });
        }

        return new Promise(resolve => {
            setTimeout(() => {
                resolve({
                    // @ts-ignore
                    data: {
                        affid: 'welcome50-lp209',
                        code: 0,
                        customerEmail: '5dce7a6976fd1798a1304b96372fb59c74481537',
                        customerId: '5dce7a6976fd1798a1304b96372fb59c74481537',
                        description: 'Thank you for your subscription.',
                        orderId: '42',
                        redirect: '/',
                    },
                });
            }, 300);
        });
    }

    const {radioValue} = get(modal);
    const {referral, ...extraUrlData} = getExtraUrlData();
    const referralValue = /facebook/i.test(extraUrlData?.utmSource) ? 'facebook' : referral;
    const gender =
        radioValue === 'Male' || radioValue === 'Female' ? radioValue.toLowerCase() : undefined;

    return instance.post<T>(ENDPOINTS.CUSTOMER_SET_SUBSCRIBE, {
        email: data.email,
        subscribed_from: 'welcomePopup',
        affid: data.affiliateId,
        offer_given: data.offerGiven,
        verify_real_email: true,
        ref_id: data.refId,
        referral: referralValue,
        utmData: {
            ...extraUrlData,
        },
        client: {
            client_region_name: null,
            client_country_name: null,
            remoteIp: getRemoteIp(),
            timezone: getTimezone(),
            user_agent: window.navigator.userAgent,
        },
        subscription_method: 'Manual',
        gender,
    });
};
